import React from 'react';
import ChoiceButton from './ChoiceButton';

const nutritionColorScheme = {
  bgColor: '#F7F4F1',
  labelShadowColor: 'rgba(249, 115, 22, 0.40)',
  labelDropShadowColor: 'rgba(249, 115, 22, 0.40)',
  textColor: '#F97316',
  activeGradientStart: '#BC5914',
  activeGradientEnd: '#F97316',
  activeBorderGradientStart: '#F0C7AA',
  activeBorderGradientEnd: '#CF5B0A',
  activeBoxShadowColor: '#FFC772',
  activeLabelInnerBg: '#F97316',
};

const NutritionChoiceButton = (props) => {
  return <ChoiceButton {...props} colorScheme={nutritionColorScheme} />;
};

export default NutritionChoiceButton;
